export const ENV = process.env.REACT_APP_ENV;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL

export const PER_PAGE = 25